export var PdEventType;
(function (PdEventType) {
    PdEventType["PV"] = "private";
    PdEventType["IN"] = "internal";
    PdEventType["RE"] = "repair";
    PdEventType["ED"] = "education";
    PdEventType["MA"] = "maintenance";
    PdEventType["WE"] = "wedding";
    PdEventType["PA"] = "party";
    PdEventType["BP"] = "businessparty";
    PdEventType["BI"] = "birthday";
    PdEventType["HO"] = "holliday";
    PdEventType["OT"] = "other";
})(PdEventType || (PdEventType = {}));
export var PdEventBusinessStatus;
(function (PdEventBusinessStatus) {
    PdEventBusinessStatus["PV"] = "privat";
    PdEventBusinessStatus["BI"] = "billable";
    PdEventBusinessStatus["NO"] = "nobill";
})(PdEventBusinessStatus || (PdEventBusinessStatus = {}));
export var PdParticipantType;
(function (PdParticipantType) {
    PdParticipantType["WO"] = "work";
    PdParticipantType["CU"] = "cust";
    PdParticipantType["OT"] = "other";
})(PdParticipantType || (PdParticipantType = {}));
//# sourceMappingURL=pd-event-model.js.map